
import React from "react";
import AddAlert from "@material-ui/icons/AddAlert";
import withStyles from "material-ui/styles/withStyles";

import Snackbars from "components/Snackbar/Snackbar.jsx";
import snackbarContentStyle from "assets/jss/material-dashboard-pro-react/components/snackbarContentStyle.jsx";

class Snackbar extends React.Component {

  render() {
      let type = "danger";
      if (this.props.snackBarType)
        type = this.props.snackBarType;

          return(
              <Snackbars
                  place="tc"
                  color={type}
                  icon={AddAlert}
                  message={this.props.formErrorMessage}
                  open={this.props.errorSnackbarOpen}
                  closeNotification={this.props.closeErrorSnackbar}
                  close
                />)
  }
}

export default withStyles(snackbarContentStyle)(Snackbar);


// WEBPACK FOOTER //
// ./src/views/callform/components/CustomErrorSnackBar.js